const generarPoolPreguntas = (
	preguntas,
	componenteId,
	relacionesTemaComponente
) => {

	if (
		!preguntas ||
		!componenteId
	) {
		return [];
	}

	const temasPermitidos =
		relacionesTemaComponente
			.filter(
				r =>
					r.Componentes?.includes(
						Number(componenteId)
					)
			)
			.map(
				r => Number(r.TemaID)
			);

	const filtradas =
		preguntas.filter(
			pregunta => {

				const temasPregunta = [

					pregunta.Tema1,

					pregunta.Tema2,

					pregunta.Tema3,

					pregunta.Tema4

				].filter(Boolean);

				return temasPregunta.some(
					tema =>
						temasPermitidos.includes(
							Number(tema)
						)
				);
			}
		);

	return filtradas;
};

export default generarPoolPreguntas;